@for (member of $visibleMembers(); track member._id) {
    <div class="room-presence-item" [attr.title]="member.name">
        <w-avatar [value]="avatarValue(member.name)" [size]="$size()"></w-avatar>
    </div>
}
@if ($overflowCount() > 0) {
    <div class="room-presence-item">
        <w-avatar [value]="$overflowLabel()" [mode]="AvatarMode.Text" [size]="$size()"></w-avatar>
    </div>
}
